import {get,post} from '@/util/http';
import { Notification } from 'uiv'

const cifi = {
    state:{},
    mutations:{},
    actions:{
        async findByType({}, params){//组委会领导，领导寄语，五大洲的声音的接口
            const res = await get('/CifitSystem/api/aboutFair/findByType.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async sponsorsList({}, params){//历届赞助机构->历届赞助机构
            const res = await get('/CifitSystem/api/aboutFair/sponsorsList.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async brandNoticeList({}, params){//历届赞助机构->品牌合作公告
            const res = await get('/CifitSystem/api/aboutFair/brandNoticeList.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async brandNotice({}, params){//历届赞助机构->品牌合作公告-详情
            const res = await get('/CifitSystem/api/aboutFair/brandNotice.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async charmingList({}, params){//迷人的厦门
            const res = await get('/CifitSystem/api/aboutFair/charmingList.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async charmingInfo({}, params){//迷人的厦门详情
            const res = await get('/CifitSystem/api/aboutFair/charmingInfo.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async introduction({}, params){//投洽会简介
            const res = await get('/CifitSystem/api/aboutFair/introduction.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
    }
}

export default cifi


// WEBPACK FOOTER //
// ./src/store/modules/cifi.js